/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnalitoResponse,
  AtualizarAnalitoDto,
  AtualizarExameCatalogoDto,
  CatalogoExameDetalheResponse,
  CatalogoExamesControllerListarParams,
  CategoriasResponse,
  CriarAnalitoDto,
  CriarExameCatalogoDto,
  DefinirAtivoCatalogoDto,
  ErroResponse,
  PaginaDeCatalogoExamesResponse,
  PendenciaResolvidaResponse,
  PendenciasDoLaboratorioResponse,
  ReconciliarAnalitosDto,
  ReferenciaDto,
  ReferenciaResponse,
  ResolverPendenciaDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCatalogoExamesControllerListarUrl = (params?: CatalogoExamesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/catalogo-exames?${stringifiedParams}` : `/v1/admin/catalogo-exames`
}

/**
 * @summary Lista o catálogo, paginado
 */
export const catalogoExamesControllerListar = async (params?: CatalogoExamesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCatalogoExamesResponse> => {

  return httpClient<PaginaDeCatalogoExamesResponse>(getCatalogoExamesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesControllerListarQueryKey = (params?: CatalogoExamesControllerListarParams,) => {
    return [
    `/v1/admin/catalogo-exames`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoExamesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError = ErroResponse>(params?: CatalogoExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesControllerListar>>> = ({ signal }) => catalogoExamesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerListar>>>
export type CatalogoExamesControllerListarQueryError = ErroResponse


export function useCatalogoExamesControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError = ErroResponse>(
 params: undefined |  CatalogoExamesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError = ErroResponse>(
 params?: CatalogoExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError = ErroResponse>(
 params?: CatalogoExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o catálogo, paginado
 */

export function useCatalogoExamesControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError = ErroResponse>(
 params?: CatalogoExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesControllerCriarUrl = () => {




  return `/v1/admin/catalogo-exames`
}

/**
 * @summary Cria um exame no catálogo
 */
export const catalogoExamesControllerCriar = async (criarExameCatalogoDto: CriarExameCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarExameCatalogoDto)
  }
);}





export const getCatalogoExamesControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriar>>, TError,{data: CriarExameCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriar>>, TError,{data: CriarExameCatalogoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerCriar>>, {data: CriarExameCatalogoDto}> = (props) => {
          const {data} = props ?? {};

          return  catalogoExamesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerCriar>>>
    export type CatalogoExamesControllerCriarMutationBody = CriarExameCatalogoDto
    export type CatalogoExamesControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um exame no catálogo
 */
export const useCatalogoExamesControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriar>>, TError,{data: CriarExameCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerCriar>>,
        TError,
        {data: CriarExameCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerCriarMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerCategoriasUrl = () => {




  return `/v1/admin/catalogo-exames/categorias`
}

/**
 * @summary Categorias já em uso, para alimentar o filtro
 */
export const catalogoExamesControllerCategorias = async ( options?: Parameters<typeof httpClient>[1]): Promise<CategoriasResponse> => {

  return httpClient<CategoriasResponse>(getCatalogoExamesControllerCategoriasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesControllerCategoriasQueryKey = () => {
    return [
    `/v1/admin/catalogo-exames/categorias`
    ] as const;
    }


export const getCatalogoExamesControllerCategoriasQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesControllerCategoriasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>> = ({ signal }) => catalogoExamesControllerCategorias({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesControllerCategoriasQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>>
export type CatalogoExamesControllerCategoriasQueryError = unknown


export function useCatalogoExamesControllerCategorias<TData = Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerCategorias<TData = Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerCategorias<TData = Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Categorias já em uso, para alimentar o filtro
 */

export function useCatalogoExamesControllerCategorias<TData = Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerCategorias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesControllerCategoriasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesControllerPendenciasUrl = () => {




  return `/v1/admin/catalogo-exames/pendencias`
}

/**
 * @summary Nomes de teste que o laboratório mandou e que não casaram com analito. Vem com os analitos do exame para o admin escolher.
 */
export const catalogoExamesControllerPendencias = async ( options?: Parameters<typeof httpClient>[1]): Promise<PendenciasDoLaboratorioResponse> => {

  return httpClient<PendenciasDoLaboratorioResponse>(getCatalogoExamesControllerPendenciasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesControllerPendenciasQueryKey = () => {
    return [
    `/v1/admin/catalogo-exames/pendencias`
    ] as const;
    }


export const getCatalogoExamesControllerPendenciasQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesControllerPendenciasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>> = ({ signal }) => catalogoExamesControllerPendencias({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesControllerPendenciasQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>>
export type CatalogoExamesControllerPendenciasQueryError = unknown


export function useCatalogoExamesControllerPendencias<TData = Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerPendencias<TData = Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerPendencias<TData = Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Nomes de teste que o laboratório mandou e que não casaram com analito. Vem com os analitos do exame para o admin escolher.
 */

export function useCatalogoExamesControllerPendencias<TData = Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerPendencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesControllerPendenciasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesControllerResolverPendenciaUrl = (pendenciaId: string,) => {




  return `/v1/admin/catalogo-exames/pendencias/${pendenciaId}`
}

/**
 * @summary Resolve a pendência: vira apelido de um analito, cria o analito que falta, ou é ignorada.
 */
export const catalogoExamesControllerResolverPendencia = async (pendenciaId: string,
    resolverPendenciaDto: ResolverPendenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<PendenciaResolvidaResponse> => {

  return httpClient<PendenciaResolvidaResponse>(getCatalogoExamesControllerResolverPendenciaUrl(pendenciaId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolverPendenciaDto)
  }
);}





export const getCatalogoExamesControllerResolverPendenciaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>, TError,{pendenciaId: string;data: ResolverPendenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>, TError,{pendenciaId: string;data: ResolverPendenciaDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerResolverPendencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>, {pendenciaId: string;data: ResolverPendenciaDto}> = (props) => {
          const {pendenciaId,data} = props ?? {};

          return  catalogoExamesControllerResolverPendencia(pendenciaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerResolverPendenciaMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>>
    export type CatalogoExamesControllerResolverPendenciaMutationBody = ResolverPendenciaDto
    export type CatalogoExamesControllerResolverPendenciaMutationError = ErroResponse

    /**
 * @summary Resolve a pendência: vira apelido de um analito, cria o analito que falta, ou é ignorada.
 */
export const useCatalogoExamesControllerResolverPendencia = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>, TError,{pendenciaId: string;data: ResolverPendenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerResolverPendencia>>,
        TError,
        {pendenciaId: string;data: ResolverPendenciaDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerResolverPendenciaMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerObterUrl = (id: string,) => {




  return `/v1/admin/catalogo-exames/${id}`
}

/**
 * @summary Detalha o exame com analitos e faixas
 */
export const catalogoExamesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/catalogo-exames/${id}`
    ] as const;
    }


export const getCatalogoExamesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesControllerObter>>> = ({ signal }) => catalogoExamesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerObter>>>
export type CatalogoExamesControllerObterQueryError = ErroResponse


export function useCatalogoExamesControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha o exame com analitos e faixas
 */

export function useCatalogoExamesControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/catalogo-exames/${id}`
}

/**
 * @summary Atualiza o exame
 */
export const catalogoExamesControllerAtualizar = async (id: string,
    atualizarExameCatalogoDto: AtualizarExameCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarExameCatalogoDto)
  }
);}





export const getCatalogoExamesControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>, TError,{id: string;data: AtualizarExameCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>, TError,{id: string;data: AtualizarExameCatalogoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>, {id: string;data: AtualizarExameCatalogoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoExamesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>>
    export type CatalogoExamesControllerAtualizarMutationBody = AtualizarExameCatalogoDto
    export type CatalogoExamesControllerAtualizarMutationError = unknown

    /**
 * @summary Atualiza o exame
 */
export const useCatalogoExamesControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>, TError,{id: string;data: AtualizarExameCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarExameCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/catalogo-exames/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. É o "excluir" — o histórico de exames aponta para o item.
 */
export const catalogoExamesControllerDefinirAtivo = async (id: string,
    definirAtivoCatalogoDto: DefinirAtivoCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoCatalogoDto)
  }
);}





export const getCatalogoExamesControllerDefinirAtivoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCatalogoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>, {id: string;data: DefinirAtivoCatalogoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoExamesControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>>
    export type CatalogoExamesControllerDefinirAtivoMutationBody = DefinirAtivoCatalogoDto
    export type CatalogoExamesControllerDefinirAtivoMutationError = unknown

    /**
 * @summary Ativa ou desativa. É o "excluir" — o histórico de exames aponta para o item.
 */
export const useCatalogoExamesControllerDefinirAtivo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerDefinirAtivoMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerCriarAnalitoUrl = (id: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos`
}

/**
 * @summary Adiciona um analito. Sem `ordem`, entra no fim.
 */
export const catalogoExamesControllerCriarAnalito = async (id: string,
    criarAnalitoDto: CriarAnalitoDto, options?: Parameters<typeof httpClient>[1]): Promise<AnalitoResponse> => {

  return httpClient<AnalitoResponse>(getCatalogoExamesControllerCriarAnalitoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarAnalitoDto)
  }
);}





export const getCatalogoExamesControllerCriarAnalitoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>, TError,{id: string;data: CriarAnalitoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>, TError,{id: string;data: CriarAnalitoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerCriarAnalito'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>, {id: string;data: CriarAnalitoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoExamesControllerCriarAnalito(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerCriarAnalitoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>>
    export type CatalogoExamesControllerCriarAnalitoMutationBody = CriarAnalitoDto
    export type CatalogoExamesControllerCriarAnalitoMutationError = ErroResponse

    /**
 * @summary Adiciona um analito. Sem `ordem`, entra no fim.
 */
export const useCatalogoExamesControllerCriarAnalito = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>, TError,{id: string;data: CriarAnalitoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerCriarAnalito>>,
        TError,
        {id: string;data: CriarAnalitoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerCriarAnalitoMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerReconciliarAnalitosUrl = (id: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos`
}

/**
 * @summary Grava a árvore INTEIRA de analitos e faixas de uma vez (a grade). Analito fora da lista é desativado; faixa fora da lista é excluída.
 */
export const catalogoExamesControllerReconciliarAnalitos = async (id: string,
    reconciliarAnalitosDto: ReconciliarAnalitosDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesControllerReconciliarAnalitosUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reconciliarAnalitosDto)
  }
);}





export const getCatalogoExamesControllerReconciliarAnalitosMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>, TError,{id: string;data: ReconciliarAnalitosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>, TError,{id: string;data: ReconciliarAnalitosDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerReconciliarAnalitos'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>, {id: string;data: ReconciliarAnalitosDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoExamesControllerReconciliarAnalitos(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerReconciliarAnalitosMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>>
    export type CatalogoExamesControllerReconciliarAnalitosMutationBody = ReconciliarAnalitosDto
    export type CatalogoExamesControllerReconciliarAnalitosMutationError = ErroResponse

    /**
 * @summary Grava a árvore INTEIRA de analitos e faixas de uma vez (a grade). Analito fora da lista é desativado; faixa fora da lista é excluída.
 */
export const useCatalogoExamesControllerReconciliarAnalitos = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>, TError,{id: string;data: ReconciliarAnalitosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerReconciliarAnalitos>>,
        TError,
        {id: string;data: ReconciliarAnalitosDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerReconciliarAnalitosMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerAtualizarAnalitoUrl = (id: string,
    analitoId: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos/${analitoId}`
}

/**
 * @summary Atualiza um analito
 */
export const catalogoExamesControllerAtualizarAnalito = async (id: string,
    analitoId: string,
    atualizarAnalitoDto: AtualizarAnalitoDto, options?: Parameters<typeof httpClient>[1]): Promise<AnalitoResponse> => {

  return httpClient<AnalitoResponse>(getCatalogoExamesControllerAtualizarAnalitoUrl(id,analitoId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarAnalitoDto)
  }
);}





export const getCatalogoExamesControllerAtualizarAnalitoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>, TError,{id: string;analitoId: string;data: AtualizarAnalitoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>, TError,{id: string;analitoId: string;data: AtualizarAnalitoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerAtualizarAnalito'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>, {id: string;analitoId: string;data: AtualizarAnalitoDto}> = (props) => {
          const {id,analitoId,data} = props ?? {};

          return  catalogoExamesControllerAtualizarAnalito(id,analitoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerAtualizarAnalitoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>>
    export type CatalogoExamesControllerAtualizarAnalitoMutationBody = AtualizarAnalitoDto
    export type CatalogoExamesControllerAtualizarAnalitoMutationError = unknown

    /**
 * @summary Atualiza um analito
 */
export const useCatalogoExamesControllerAtualizarAnalito = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>, TError,{id: string;analitoId: string;data: AtualizarAnalitoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerAtualizarAnalito>>,
        TError,
        {id: string;analitoId: string;data: AtualizarAnalitoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerAtualizarAnalitoMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerDefinirAtivoAnalitoUrl = (id: string,
    analitoId: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos/${analitoId}/ativo`
}

/**
 * @summary Ativa ou desativa o analito
 */
export const catalogoExamesControllerDefinirAtivoAnalito = async (id: string,
    analitoId: string,
    definirAtivoCatalogoDto: DefinirAtivoCatalogoDto, options?: Parameters<typeof httpClient>[1]): Promise<AnalitoResponse> => {

  return httpClient<AnalitoResponse>(getCatalogoExamesControllerDefinirAtivoAnalitoUrl(id,analitoId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoCatalogoDto)
  }
);}





export const getCatalogoExamesControllerDefinirAtivoAnalitoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>, TError,{id: string;analitoId: string;data: DefinirAtivoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>, TError,{id: string;analitoId: string;data: DefinirAtivoCatalogoDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerDefinirAtivoAnalito'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>, {id: string;analitoId: string;data: DefinirAtivoCatalogoDto}> = (props) => {
          const {id,analitoId,data} = props ?? {};

          return  catalogoExamesControllerDefinirAtivoAnalito(id,analitoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerDefinirAtivoAnalitoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>>
    export type CatalogoExamesControllerDefinirAtivoAnalitoMutationBody = DefinirAtivoCatalogoDto
    export type CatalogoExamesControllerDefinirAtivoAnalitoMutationError = unknown

    /**
 * @summary Ativa ou desativa o analito
 */
export const useCatalogoExamesControllerDefinirAtivoAnalito = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>, TError,{id: string;analitoId: string;data: DefinirAtivoCatalogoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerDefinirAtivoAnalito>>,
        TError,
        {id: string;analitoId: string;data: DefinirAtivoCatalogoDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerDefinirAtivoAnalitoMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerCriarReferenciaUrl = (id: string,
    analitoId: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos/${analitoId}/referencias`
}

/**
 * @summary Cria uma faixa. Numérica OU textual, nunca as duas.
 */
export const catalogoExamesControllerCriarReferencia = async (id: string,
    analitoId: string,
    referenciaDto: ReferenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<ReferenciaResponse> => {

  return httpClient<ReferenciaResponse>(getCatalogoExamesControllerCriarReferenciaUrl(id,analitoId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenciaDto)
  }
);}





export const getCatalogoExamesControllerCriarReferenciaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>, TError,{id: string;analitoId: string;data: ReferenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>, TError,{id: string;analitoId: string;data: ReferenciaDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerCriarReferencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>, {id: string;analitoId: string;data: ReferenciaDto}> = (props) => {
          const {id,analitoId,data} = props ?? {};

          return  catalogoExamesControllerCriarReferencia(id,analitoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerCriarReferenciaMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>>
    export type CatalogoExamesControllerCriarReferenciaMutationBody = ReferenciaDto
    export type CatalogoExamesControllerCriarReferenciaMutationError = ErroResponse

    /**
 * @summary Cria uma faixa. Numérica OU textual, nunca as duas.
 */
export const useCatalogoExamesControllerCriarReferencia = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>, TError,{id: string;analitoId: string;data: ReferenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerCriarReferencia>>,
        TError,
        {id: string;analitoId: string;data: ReferenciaDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerCriarReferenciaMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerAtualizarReferenciaUrl = (id: string,
    analitoId: string,
    referenciaId: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos/${analitoId}/referencias/${referenciaId}`
}

/**
 * @summary Atualiza a faixa
 */
export const catalogoExamesControllerAtualizarReferencia = async (id: string,
    analitoId: string,
    referenciaId: string,
    referenciaDto: ReferenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<ReferenciaResponse> => {

  return httpClient<ReferenciaResponse>(getCatalogoExamesControllerAtualizarReferenciaUrl(id,analitoId,referenciaId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(referenciaDto)
  }
);}





export const getCatalogoExamesControllerAtualizarReferenciaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>, TError,{id: string;analitoId: string;referenciaId: string;data: ReferenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>, TError,{id: string;analitoId: string;referenciaId: string;data: ReferenciaDto}, TContext> => {

const mutationKey = ['catalogoExamesControllerAtualizarReferencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>, {id: string;analitoId: string;referenciaId: string;data: ReferenciaDto}> = (props) => {
          const {id,analitoId,referenciaId,data} = props ?? {};

          return  catalogoExamesControllerAtualizarReferencia(id,analitoId,referenciaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerAtualizarReferenciaMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>>
    export type CatalogoExamesControllerAtualizarReferenciaMutationBody = ReferenciaDto
    export type CatalogoExamesControllerAtualizarReferenciaMutationError = unknown

    /**
 * @summary Atualiza a faixa
 */
export const useCatalogoExamesControllerAtualizarReferencia = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>, TError,{id: string;analitoId: string;referenciaId: string;data: ReferenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerAtualizarReferencia>>,
        TError,
        {id: string;analitoId: string;referenciaId: string;data: ReferenciaDto},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerAtualizarReferenciaMutationOptions(options), queryClient);
    }
    export const getCatalogoExamesControllerExcluirReferenciaUrl = (id: string,
    analitoId: string,
    referenciaId: string,) => {




  return `/v1/admin/catalogo-exames/${id}/analitos/${analitoId}/referencias/${referenciaId}`
}

/**
 * @summary Exclui a faixa. É o único delete real: faixa errada some, não é escondida.
 */
export const catalogoExamesControllerExcluirReferencia = async (id: string,
    analitoId: string,
    referenciaId: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getCatalogoExamesControllerExcluirReferenciaUrl(id,analitoId,referenciaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCatalogoExamesControllerExcluirReferenciaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>, TError,{id: string;analitoId: string;referenciaId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>, TError,{id: string;analitoId: string;referenciaId: string}, TContext> => {

const mutationKey = ['catalogoExamesControllerExcluirReferencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>, {id: string;analitoId: string;referenciaId: string}> = (props) => {
          const {id,analitoId,referenciaId} = props ?? {};

          return  catalogoExamesControllerExcluirReferencia(id,analitoId,referenciaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoExamesControllerExcluirReferenciaMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>>

    export type CatalogoExamesControllerExcluirReferenciaMutationError = unknown

    /**
 * @summary Exclui a faixa. É o único delete real: faixa errada some, não é escondida.
 */
export const useCatalogoExamesControllerExcluirReferencia = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>, TError,{id: string;analitoId: string;referenciaId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoExamesControllerExcluirReferencia>>,
        TError,
        {id: string;analitoId: string;referenciaId: string},
        TContext
      > => {
      return useMutation(getCatalogoExamesControllerExcluirReferenciaMutationOptions(options), queryClient);
    }
